/**
 * Url
 */

class Url {

  static getParams() {
    const _vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, ( m, key, value ) => {
     _vars[ key ] = value;
    });
    return _vars;
  }

  static hashs( url ) {

    if ( !url ) {
      return '';
    }

    const vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, ( m, key, value ) => {
      vars[ key ] = value;
    });
    return vars;
  }

  static getHash() {
    let _hash = document.location.hash;
    _hash = _hash.replace( '#', '' );
    return _hash;
  }
}
export default Url;
